module.exports = __webpack_public_path__ + "img/langfang.49895477.jpg";